/*
 * The onData pattern allows for broadcast and notification of various types of data elements. This is especially 
 * useful when paging between results and wanting to expose data elements such as a BusinessName to the whole page
 * without having to couple the code that owns the data with the elements that need to display it.
 * 
 * @see 50-DataEvents.js for specific event types
 */
(function($, obj) {
	$.extend(obj, {
		triggerDataEvent: function(event, data) {
			if ( typeof event == 'object' ) {
				$.each(event, function(k, v) {
					obj.triggerDataEvent(k, v);
				});
			} else {
				$(document)
					.trigger('originDataEvent', [event, data])
					.trigger('data' + Origin.ConvertCamelToPascal(event), [data]);
					
			}
		},
		/*
		 * This method takes an event name (such as totalRecordCount), a selector to execute when that event occurs
		 * (such as .data-total-record-count), and finally a callback method to execute when the event is triggered.
		 */
		bindDataEvent: function(event, selector, callback) {
			if ($.isFunction(selector)) {
				callback = selector;
				selector = document;
			}
			$(document).bind('data' + Origin.ConvertCamelToPascal(event), function() {
				// Strip off the 'native' jQuery event object
				var args = Array.prototype.slice.call(arguments, 1);
				$(selector).each(function() {
					callback.apply(this, args);
				});
			});
		},
		
		/*
		 * A generic method for binding a data event callback handler without specifying a DOM node.
		 * This allows for non DOM specific operations to take place.
		 */
		onData: function(event, callback) {
			$(document).bind('data' + Origin.ConvertCamelToPascal(event), function() {
				callback.apply({}, Array.prototype.slice.call(arguments, 1));
			});
		}
	});
})(jQuery, Origin);